// extracted by mini-css-extract-plugin
export default {"inline":"InlineData_inline__n8tce","inlineLabel":"InlineData_inlineLabel__UzBhy","inlineValue":"InlineData_inlineValue__q8vOJ"};